import { useEffect, useRef, useState } from "react";
import pkdex from '../pkdex.png'
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from 'react-helmet'

export default function Pkdex() {
  const [trackingId, setTrackingId] = useState("");
  const [countdown, setCountdown] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const messageRef = useRef(null);

  useEffect(() => {
    document.getElementById("searchBox")?.focus();
  }, []);

  useEffect(() => {
    let timer;
    if (countdown !== null && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      setLoading(false);
      setMessage(
        `Sorry, we could not track your delivery. However, you can use the official website or contact the information provided below to call or email them.\n\n` +
          `<a class='t' href='#contact'>Contact Information</a>`
      );
      setCountdown(null);
      messageRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (trackingId.length < 6) {
      alert("Invalid Tracking ID, Please Enter Correct ID");
      return;
    }
    setLoading(true);
    setMessage("");
    setCountdown(10);
  };

  return (
    <div>
      <Header/>
      <Helmet>
  <html lang="en" />
  <title>PK-DEX – Track Your Packages in Real-Time | Tooliso</title>
  <meta
    name="description"
    content="Track your packages from multiple couriers in Pakistan with PK-DEX. Enter your tracking number to get real-time updates. Fast, simple, and reliable."
  />
  <link rel="canonical" href="https://tooliso.com/pkdex" />

  <meta property="og:title" content="PK-DEX – Pakistan's Package Tracker by Tooliso" />
  <meta
    property="og:description"
    content="Use PK-DEX to track your parcel in real-time across top Pakistani courier services. No app needed – just enter your tracking number."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tooliso.com/pkdex" />

  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="PK-DEX – Track Packages from Any Courier | Tooliso" />
  <meta
    name="twitter:description"
    content="Track your shipments easily with PK-DEX by Tooliso. Real-time tracking for packages sent via multiple Pakistani courier services."
  />
</Helmet>

      <div className="container" style={{marginTop:"100px"}}>
      <div className="center" id="tracking">
        <img alt="PK-DEX Tracking Logo" src={pkdex}/>
        <h1>PK-DEX Tracking - Track Daraz Orders in Pakistan Easily</h1>
        <p>
          <b>Enter your PK-DEX tracking number to track the delivery:</b>
        </p>
        <form onSubmit={handleSubmit}>
          
            <input
            required className="darazInput"
            type="text"
            id="searchBox"
            placeholder="Tracking Number"
            value={trackingId}
            onChange={(e) => setTrackingId(e.target.value)}
          />
          <button type="submit" id="searchButton">
            Track
          </button>
         
        </form>
        {loading && (
          <div id="loading">Tracking... {countdown} seconds remaining</div>
        )}
        {message && (
          <div
            id="message"
            ref={messageRef}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </div>

      <div>
        <strong>Important Notice:</strong>
        <p style={{ margin: "10px 0" }}>
          Please note that <strong>Dreamco Express</strong> is not affiliated with
          Daraz.pk and is not the delivery agent or vendor for Daraz orders. The
          tracking number starting with <strong>"DEX-PK"</strong> provided by Daraz
          refers to their in-house delivery service, <strong>Daraz Express</strong>. This
          is a completely separate company from Dreamco Express.
        </p>
        <p style={{ margin: "10px 0" }}>
          For any inquiries regarding your Daraz order status, please contact <strong>Daraz.pk</strong> directly.
        </p>
      </div>

      <section classname="sectionpk" id="contact">
        <h2>PK-DEX Contact Number, Email, and Official Website</h2>
        <p>
          Official Website: <a href="https://www.dex.com.pk/" target="_blank" rel="noopener noreferrer">https://www.dex.com.pk/</a>
        </p>
        <table border="1">
          <tbody>
            <tr><td>Phone#1</td><td><a style={{color:"blue"}} href="tel:+922134300631">+922134300631</a></td></tr>
            <tr><td>Phone#2</td><td><a style={{color:"blue"}} href="tel:+922134300632">+922134300632</a></td></tr>
            <tr><td>Phone#3</td><td><a style={{color:"blue"}} href="tel:+922134300633">+922134300633</a></td></tr>
            <tr><td>Phone#4</td><td><a style={{color:"blue"}} href="tel:+922134300634">+922134300634</a></td></tr>
            <tr><td>Email#1</td><td><a style={{color:"blue"}} href="mailto:support@dreamcoexpress.com.pk">support@dreamcoexpress.com.pk</a></td></tr>
            <tr><td>Email#2</td><td><a style={{color:"blue"}} href="mailto:shahrukh@dreamcoexpress.com.pk">shahrukh@dreamcoexpress.com.pk</a></td></tr>
          </tbody>
        </table>
      </section>

      <section classname="sectionpk" id="about">
        <h2>PK-DEX Tracking Services</h2>
        <p>
          PK-DEX offers reliable tracking services for your Daraz orders. Whether you need to track your order
          status, contact our helpline for support, or find your nearest PK-DEX location, we are here to help.
        </p>
        <ul>
          <li>PK-DEX tracking number: Easily track your package using your unique tracking number.</li>
          <li>PK-DEX tracking Pakistan: Get real-time updates on your package's status within Pakistan.</li>
          <li>PK-DEX tracking Daraz phone number: Contact our support team for any queries.</li>
          <li>PK-DEX courier tracking: Reliable and accurate tracking for all your shipments.</li>
          <li>PK-DEX tracking order: Stay informed about your order status from dispatch to delivery.</li>
          <li>PK-DEX helpline number: Reach out to our customer service for assistance.</li>
          <li>PK-DEX contact number: Connect with us for any inquiries about your deliveries.</li>
          <li>PK-DEX location: Find the nearest PK-DEX office for easy access to our services.</li>
        </ul>
      </section>

      <section classname="sectionpk" id="services">
        <h2>Why Choose PK-DEX for Daraz Deliveries?</h2>
        <p>
          PK-DEX is committed to providing top-notch delivery tracking services for Daraz orders. Our
          state-of-the-art tracking system ensures you are always updated on your package's location and status.
          With multiple contact options and a dedicated support team, we make sure your delivery experience is
          smooth and hassle-free.
        </p>
      </section>

      <section classname="sectionpk" id="expertise">
        <h2>Special Expertise and Services</h2>
        <p>
          With special expertise in handling and shipping to our direct destinations namely Hong Kong, Sri Lanka,
          Bangladesh, UAE, Singapore, and the UK, PK-DEX provides a complete solution for your transportation
          needs that is both extremely flexible and personalized. From pick-up to custom clearance till final
          delivery, our dedicated team ensures that your urgent shipments get to their destinations beforehand,
          maintaining the whole supply chain.
        </p>
        <p>
          Our broad range network and delivery solutions offer document delivery at extremely competitive rates all
          around the world.
        </p>
        <p>
          Flexibility! Accompanied with special packaging, delivery, and custom clearance options, all non-document
          shipments are carefully administered until they reach their final destination.
        </p>
        <ul>
          <li><strong>International Express:</strong> PK-DEX provides a complete solution for urgent
            transportation ranging from lightweight packages to bulk shipments.</li>
          <li><strong>Domestic Over Land & Rail Express:</strong> We offer alternate modes of transport for bulk
            shipments within Pakistan.</li>
          <li><strong>Domestic Express:</strong> A strong and widespread domestic network within the country,
            ensuring reliable delivery services.</li>
          <li><strong>Freight Express:</strong> PK-DEX offers economy, reliability, and better transit times for
            bulk shipping under freight mode.</li>
          <li><strong>Customs Brokerage:</strong> Our team understands complex tariff barriers and provides
            efficient customs clearance services.</li>
          <li><strong>Import Express:</strong> We provide door-to-door import services under express mode,
            ensuring your packages are shipped and delivered right to your doorstep.</li>
        </ul>
      </section>

      <section classname="sectionpk" id="faqs">
        <h2>Frequently Asked Questions (FAQs)</h2>
        <details>
          <summary>How can I track my Daraz order?</summary>
          <p>You can track your Daraz order by entering your PK-DEX tracking number in the tracking form on our homepage.</p>
        </details>
        <details>
          <summary>What should I do if my package is delayed?</summary>
          <p>If your package is delayed, please contact our support team using the contact information provided on this page.</p>
        </details>
        <details>
          <summary>Can I change the delivery address after placing an order?</summary>
          <p>Please contact our customer service to check if a change of address is possible for your shipment.</p>
        </details>
      </section>

      <section classname="sectionpk">
        <h2>How to track PK-DEX Daraz order</h2>
        <p>You can visit this page to see step by step guide</p>
      </section>

      <section classname="sectionpk" id="blog">
        <h2>Latest News and Updates</h2>
        <article>
          <h3>PK-DEX Expands Services to New Countries</h3>
          <p>We are excited to announce the expansion of our services to new countries, including Australia and Canada. Stay tuned for more updates!</p>
          <a href="https://www.dex.com.pk/news" target="_blank" rel="noopener noreferrer">Read more</a>
        </article>
        <article>
          <h3>How to Ensure Your Package is Delivered on Time</h3>
          <p>Learn some tips and tricks to make sure your package is delivered on time without any issues.</p>
          <a href="https://www.dex.com.pk/blog" target="_blank" rel="noopener noreferrer">Read more</a>
        </article>
      </section>

      <section classname="sectionpk" id="social-media">
        <h2>Connect with Us</h2>
        <p>Follow us on social media to stay updated with the latest news and offers.</p>
        <ul>
          <li><a style={{color:"blue"}} href="https://facebook.com/p/DEX-Courier-100064159351772/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer">Facebook</a></li>
          <li><a style={{color:"blue"}} href="https://www.instagram.com/dex.pk/" target="_blank">Instagram</a></li>
        </ul>
      </section>
    </div>

      <Footer/>
    </div>
  );
}
